/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Operator_DescriptionInputs */

const en_users_form_group_operator_description = /** @type {(inputs: Users_Form_Group_Operator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal user responsible for creating cases and assigning tasks.`)
};

const pt_br2_users_form_group_operator_description = /** @type {(inputs: Users_Form_Group_Operator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário interno responsável por criar casos e atribuir tarefas.`)
};

/**
* | output |
* | --- |
* | "Internal user responsible for creating cases and assigning tasks." |
*
* @param {Users_Form_Group_Operator_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_operator_description = /** @type {((inputs?: Users_Form_Group_Operator_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Operator_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_operator_description(inputs)
	return pt_br2_users_form_group_operator_description(inputs)
});